/*
 * Tells a signed-in ARTIST Rewards member, in the cart, how many points they
 * hold and that they can turn them into a discount code at checkout.
 *
 * Markup contract (snippets/cart-discount-form.liquid):
 *   [data-cart-rewards]           the message, `hidden` until filled
 *     data-template               the message text with __POINTS__ where the
 *                                 number goes
 *
 * Toki's balance lives only in JavaScript (window.tokiWallet). Its member
 * methods throw for guests, and the balance payload shape is undocumented, so
 * the number is read defensively. Every failure path leaves the message
 * hidden: no Toki script, a guest, a thrown call, an unreadable payload, or a
 * zero balance all show nothing. Written in ES5 syntax so an old browser
 * degrades to doing nothing rather than failing to parse.
 */
(function () {
  var POLL_MS = 250;
  var MAX_TRIES = 60;
  var BALANCE_KEYS = [
    'balance', 'availableBalance', 'available_balance', 'available',
    'currentBalance', 'current_balance', 'totalBalance', 'total_balance',
    'points', 'pointsBalance', 'points_balance', 'amount', 'value'
  ];

  var pending = null;

  function waitForWallet(tries, done) {
    var wallet = window.tokiWallet;

    if (wallet && typeof wallet.toki_check_user_authenticated === 'function' && typeof wallet.getUserBalance === 'function') {
      done(wallet);
      return;
    }

    if (tries >= MAX_TRIES) return;

    setTimeout(function () {
      waitForWallet(tries + 1, done);
    }, POLL_MS);
  }

  function toNumber(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    if (typeof value === 'string' && /^\s*-?\d+(\.\d+)?\s*$/.test(value)) return parseFloat(value);
    return null;
  }

  /* Walks the payload for the first balance-like number: a bare number, a known key, or one nested level down. */
  function readBalance(payload, depth) {
    var direct = toNumber(payload);
    if (direct !== null) return direct;
    if (!payload || typeof payload !== 'object' || depth > 3) return null;

    if (Object.prototype.toString.call(payload) === '[object Array]') {
      return payload.length ? readBalance(payload[0], depth + 1) : null;
    }

    var i;
    for (i = 0; i < BALANCE_KEYS.length; i++) {
      if (payload.hasOwnProperty(BALANCE_KEYS[i])) {
        var found = readBalance(payload[BALANCE_KEYS[i]], depth + 1);
        if (found !== null) return found;
      }
    }

    var nested = ['data', 'result', 'wallet', 'user', 'balances', 'tokens'];
    for (i = 0; i < nested.length; i++) {
      if (payload.hasOwnProperty(nested[i])) {
        var inner = readBalance(payload[nested[i]], depth + 1);
        if (inner !== null) return inner;
      }
    }

    return null;
  }

  function formatPoints(points) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { maximumFractionDigits: 0 }).format(points);
    } catch (error) {
      return String(Math.floor(points));
    }
  }

  function render(points) {
    var nodes = document.querySelectorAll('[data-cart-rewards]');

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var template = node.getAttribute('data-template') || '';
      var parts = template.split('__POINTS__');

      if (!points || points <= 0 || parts.length !== 2) {
        node.hidden = true;
        continue;
      }

      var strong = document.createElement('strong');
      strong.textContent = formatPoints(points);

      node.textContent = '';
      node.appendChild(document.createTextNode(parts[0]));
      node.appendChild(strong);
      node.appendChild(document.createTextNode(parts[1]));
      node.hidden = false;
    }
  }

  function check() {
    if (pending) return;
    if (!document.querySelector('[data-cart-rewards]')) return;

    pending = true;

    waitForWallet(0, function (wallet) {
      try {
        Promise.resolve(wallet.toki_check_user_authenticated())
          .then(function (isMember) {
            if (!isMember) return null;
            return wallet.getUserBalance({ shopDomain: wallet.config && wallet.config.shopDomain });
          })
          .then(function (payload) {
            window.artistCartRewards.lastBalance = payload;
            render(payload == null ? null : readBalance(payload, 0));
          })
          .catch(function () {
            render(null);
          })
          .then(function () {
            pending = false;
          });
      } catch (error) {
        /* Toki changed shape under us; the message stays hidden. */
        pending = false;
      }
    });
  }

  if (!window.artistCartRewards) {
    window.artistCartRewards = { refresh: check, readBalance: readBalance, render: render, lastBalance: null };

    /* Re-check whenever a drawer opens, in case the visitor signed in to Toki since the page loaded. Capture phase, because the event may not bubble. */
    document.addEventListener('theme:drawer:open', check, true);
    document.addEventListener('shopify:section:load', check);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', check);
    } else {
      check();
    }
  }
})();
